export interface PTZEventMotionDetection {
    TriggerSensitivity: number;
    MotionEnable: number;
    DynamicAnalysisEnable: DynamicAnalysis;
    Activecell: ActiveCells;
    DetectionMode: DetectionMode;
    WindowRectangle: string;
    RegionInfoList: RegionInfoList[];
    ScheduleList: Schedule[];
}

export enum DynamicAnalysis {
    Disable,
    Enable,
}

export enum ActiveCells {
    Normal,
    Compatible,
}

export enum DetectionMode {
    Normal,
    Advanced,
}

interface RegionInfoList {
    RegionIndex: number;
    Sensitivity: number;
    AreaRegion: string;
}

interface Schedule {
    ScheduleIndex: number;
    Schedule: string;
}
